import React, { useEffect, useState } from 'react'
import { Button, Card, CardBody, Table, TabPane } from "reactstrap";
import { GET_ADD_LEAD_COLUMN, GET_LEAD_COLUMN } from '../../../../../helpers/url_helper';
import { APIClient } from '../../../../../helpers/api_helper';
import Toast from '../../../../../Components/Common/Toast';
import { ToastContainer } from 'react-toastify';

const api = new APIClient();

const getStaticColumn = [{
  "firstName": "First Name",
  "lastName": "Last Name",
  "email": "Email",
  "phone": "Phone Number",
  "alternatePhoneNumber": "Alt. Phone Number",
  "status": "Status",
  "assignedTo": "Assign To",
  "companyName": "Company Name",
  "address1": "Address 1",
  "address2": "Address 2",
  "source": "Source",
  "dealAmount": "Deal Amount",
  "city": "City",
  "country": "Country",
  "description": "Description",
  "pincode": "Pincode",
  "mapCallLogs": "Map CallLogs",
  "countryCode": "Country Code",
  "state": "State",
  "createdAt": "2025-02-06T12:31:07.821Z",
  "updatedAt": "2025-02-07T08:21:50.323Z"
}]

const MapFields = ({ toggleArrowTab, activeArrowTab, csvHeaders, setActionVisible, setCsvHeaders, setFiles, setIsDragging, setactiveArrowTab }) => {
  const [getLeadColumn, setGetLeadColumn] = useState([]);
  const [selectedFields, setSelectedFields] = useState(() => {
    const phoneField = csvHeaders.find(header => header === "Phone Number");
    return phoneField ? { phone: phoneField } : {};
  });


  useEffect(() => {
    if (csvHeaders.includes("Phone Number")) {
      setSelectedFields(prev => ({
        ...prev,
        phone: "Phone Number"
      }));
    }
  }, [csvHeaders]);



  // Modified handle select change
  const handleSelectChange = (key, value, fieldValue) => {
    // Validate first letter match
    // const firstLetterField = fieldValue.charAt(0).toLowerCase();
    // const firstLetterSelected = value.charAt(0).toLowerCase();

    // if (firstLetterField !== firstLetterSelected) {
    //   Toast(`Warning: The field "${fieldValue}" usually starts with "${firstLetterField}" but you selected "${value}"`, "warning");
    // }

    setSelectedFields(prev => ({
      ...prev,
      [key]: value
    }));

    // Clear any existing errors
    // setErrors(prev => ({
    //   ...prev,
    //   [key]: null
    // }));
  };

  // Modified submit handler
  const handleSubmit = async () => {
    // Check if Phone Number and First Name are selected anywhere
    const isPhoneSelected = Object.keys(selectedFields).includes("phone");
    const isFirstNameSelected = Object.keys(selectedFields).includes("firstName");
    if (!isFirstNameSelected && !isPhoneSelected) {
      Toast("Mapping of First Name and Phone Number columns are mandatory in CSV fields", "error");
      return;
    }

    if (!isPhoneSelected) {
      Toast("Phone Number field must be selected", "error");
      return;
    }

    if (!isFirstNameSelected) {
      Toast("First Name field must be selected", "error");
      return;
    }

    // Rest of your submit logic...
    try {
      const response = await api.create(GET_ADD_LEAD_COLUMN, selectedFields);
      if (response?.success === true) {
        Toast(response.message, "success");
        toggleArrowTab(activeArrowTab + 2);
        setActionVisible(true);
      }
    } catch (error) {
      Toast(error.response?.message || "An error occurred", "error");
      console.error("Error:", error);
    }
  };


  // // Fetch lead columns
  // const fetchLeadColumns = async () => {
  //   try {
  //     const response = await api.get(GET_LEAD_COLUMN);
  //     if (response.success === true) {
  //       setGetLeadColumn(response.data.length > 0 ? response.data : getStaticColumn);
  //     }
  //   } catch (error) {
  //     Toast("Error fetching lead columns", "error");
  //     console.error("Error fetching lead columns:", error);
  //   }
  // };

  // useEffect(() => {
  //   fetchLeadColumns();
  // }, [csvHeaders]);


  // Clear all state when back button is clicked
  const handleBack = () => {
    setFiles({ name: '' });
    setIsDragging(false);
    setCsvHeaders([]);
    // Reset file input
    const fileInput = document.getElementById('file-upload');
    if (fileInput) {
      fileInput.value = '';
    }

    // Go back to previous tab
    if (activeArrowTab > 0) {
      toggleArrowTab(activeArrowTab - 1);
    }
  };




  return (
    <>
      <ToastContainer />
      <TabPane className="sn-lead-map-field-tble-top" id="steparrow-description-info" tabId={5}>
        <div className="row sn-bulkimport-tble-select">
          <div className="col-md-12 col-sm-12">
            <Card style={{ height: "calc(100% - 2000px)" }}>
              <CardBody>
                <div className="live-preview n-tble-home-page sn-bulk-summary-table-main">
                  <div className="table-responsive">
                    <Table className="table-bordered align-middle table-nowrap mb-0">
                      <thead style={{ background: "#fff2f2" }}>
                        <tr>
                          <th scope="col sn-lead-field-tble-colum">Title</th>
                          <th scope="col sn-lead-field-tble-colum">Fields in File</th>
                        </tr>
                      </thead>
                      <tbody>
                        {getStaticColumn.map((field, index) => {
                          const fieldNames = Object.keys(field).filter(
                            key => !["createdAt", "updatedAt", "mapCallLogs", "status", "description"].includes(key)
                          );
                          return (
                            <React.Fragment key={index}>
                              {fieldNames.map((key, idx) => (
                                <tr key={`${index}-${idx}`} className="border-b">
                                  <th
                                    scope="row"
                                    className="px-4 py-2 text-left font-medium capitalize"
                                  >
                                    {field[key]}
                                  </th>
                                  <td className="px-4 py-2">
                                    <select
                                      name={key}
                                      className="form-select"
                                      value={selectedFields[key] || ""}
                                      onChange={(e) => handleSelectChange(key, e.target.value, field[key])}
                                    >
                                      <option value="" disabled>
                                        Select a column
                                      </option>
                                      {csvHeaders.map((item, itemIdx) => (
                                        <option
                                          key={itemIdx}
                                          value={item}
                                          disabled={
                                            Object.values(selectedFields).includes(item) && selectedFields[key] !== item
                                          }
                                        >
                                          {item}
                                        </option>
                                      ))}
                                    </select>
                                  </td>
                                </tr>
                              ))}
                            </React.Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </CardBody>
            </Card>

          </div>

        </div>
        <div className="gap-3 mt-4 justify-content-end">
          <div className="sn-bulk-next-back-btn me-3">
            {/* <Button type="button" onClick={() => handleSubmit()}>Submit</Button> */}
            <button
              type="button"
              className="btn btn-light btn-label previestab"
              onClick={handleBack}
            >
              <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i> Back
            </button>
            <button
              type="button"
              className="btn btn-danger btn-label right ms-auto nexttab nexttab"
              onClick={() => handleSubmit()}
            >
              <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
              Next
            </button>
          </div>
        </div>

      </TabPane >
    </>
  )
}

export default MapFields
